export default __webpack_public_path__ + "static/media/מועמדים-פוטושופ---סופי_0037s_0000_Black-&-White-6.9a399e19.png";